import axios from "axios";
import { ResponseAPIModel } from "../../../../setup/models/ResponseAPIModel";
import { LoginHistoryModel, FailedLoginModel } from "../ProfileModels";


const API_URL = process.env.REACT_APP_API_URL || '/api'
export const UPDATE_PASSWORD_URL = `${API_URL}/profile/change-password`;
export const GET_FAILED_LOGINS_URL = `${API_URL}/profile/failed-logins`;
export const GET_LOGIN_HISTORY_URL = `${API_URL}/profile/login-history`;

export function updateOwnPassword(currentPassword: string | undefined, newPassword: string, confirmPassword: string) {
    return axios.post<ResponseAPIModel<string>>(UPDATE_PASSWORD_URL, { current_password: currentPassword, new_password: newPassword, confirm_password: confirmPassword })
}

export function getFailedLogins() {
    return axios.get<ResponseAPIModel<Array<FailedLoginModel>>>(GET_FAILED_LOGINS_URL)
}

export function getLoginHistory() {
    return axios.get<ResponseAPIModel<Array<LoginHistoryModel>>>(GET_LOGIN_HISTORY_URL)
}